<template>
            <v-dialog v-model="visFl" scrollable @keydown.esc="close" @keydown.enter="doAct" max-width="380">
               <v-card>
                <v-card-title class="headline">
                  {{ $t( 'message.add_approval_title' ) }}
                </v-card-title>
                <v-card-text>
                  <v-textarea id="comment" :label="$t( 'message.add_approval_comm' )" v-model="comment"></v-textarea>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                    <v-btn id="approvalOk" color="green darken-1" text @click.native="doAct">{{ $t( 'message.ok_btn' ) }}</v-btn>
                    <v-btn id="approvalClose" color="green darken-1" text @click.native="close">{{ $t( 'message.cancel_btn' ) }}</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>   
</template>

<script>
    
import Vue from 'vue'
import{ conf } from '@/utils/confTruePLM';

export default {
  name: 'addApproval',
  data () 
  {
    return {
        visFl: false,
        
        comment: '',

        resolve: null,
        reject: null,
        valid: true
    };
  },
  computed: {
     
  },
  methods: {
      open( bsl )
      {
          this.comment = '';
          
          this.visFl = true;
          
          return new Promise( ( resolve, reject ) => 
          {
            this.resolve = resolve;
            this.reject = reject;
          });
      },
      doAct()
      {
         this.visFl = false;
         this.resolve( this.comment );
      },
      close()
      {
          this.visFl = false;
          this.reject();
      },
    }
}
</script>



